"use client";

import * as React from "react";
import { cn } from "../../lib/utils";

export interface LeaderboardRankingCardProps {
  rank: number;
  name: string;
  followers: string;
  earnings: string;
  avatar?: string;
  periodLabel?: string;
  medalIcon?: React.ReactNode;
  className?: string;
}

function getInitials(name: string): string {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");
}

export function LeaderboardRankingCard({
  rank,
  name,
  followers,
  earnings,
  avatar,
  periodLabel,
  medalIcon,
  className,
}: LeaderboardRankingCardProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-between gap-2 rounded-[8px] border border-black bg-white px-3 py-2.5 shadow-[0_4px_0_0_#000000]",
        className
      )}
      style={{
        backgroundImage:
          "linear-gradient(90deg, rgba(233, 246, 254, 0.12) 0%, rgba(233, 246, 254, 0.12) 100%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)",
      }}
    >
      <div className="flex items-center gap-3">
        <div className="flex min-w-[48px] items-center justify-center">
          {medalIcon ? (
            <div className="h-8 w-8">{medalIcon}</div>
          ) : (
            <div className="text-[28px] font-semibold text-[#ED5AA9]">#{rank}</div>
          )}
        </div>
        {avatar ? (
          <img
            src={avatar}
            alt={name}
            className="h-8 w-8 rounded-full border border-black object-cover"
          />
        ) : (
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-black bg-[#F2F4F7] text-xs font-semibold text-[#344054]">
            {getInitials(name)}
          </div>
        )}
        <div>
          <p className="text-sm font-medium text-[#475467]">{name}</p>
          <p className="text-xs text-[#667085]">{followers}</p>
        </div>
      </div>
      <div className="text-right">
        <p className="text-base font-medium text-[#ED5AA9]">{earnings}</p>
        {periodLabel ? (
          <p className="text-[10px] font-normal text-[#667085]">{periodLabel}</p>
        ) : null}
      </div>
    </div>
  );
}
